import { createContext, useContext, useState, useEffect } from 'react';

const TercerTiempoContext = createContext(null);

export function TercerTiempoProvider({ children }) {

  const [proveedores, setProveedores] = useState(() => {
    try {
      const guardados = localStorage.getItem('turival_tercertiempo');
      return guardados ? JSON.parse(guardados) : [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem('turival_tercertiempo', JSON.stringify(proveedores));
  }, [proveedores]);

  const registrarProveedor = (datos) => {
    const nuevo = {
      ...datos,
      id:        Date.now(),
      rating:    0,
      eventos:   0,
      iniciales: datos.negocio
        .split(' ')
        .filter(p => p.length > 0)
        .slice(0, 2)
        .map(p => p[0].toUpperCase())
        .join(''),
    };
    setProveedores(prev => [...prev, nuevo]);
    return nuevo;
  };

  return (
    <TercerTiempoContext.Provider value={{ proveedores, registrarProveedor }}>
      {children}
    </TercerTiempoContext.Provider>
  );
}

export function useTercerTiempo() {
  return useContext(TercerTiempoContext);
}